// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  i18nPrefix: '.',
  apiServer: {
    endpoint: 'https://xncrs3.xnhotels.com/xms/rpmv3duo/api',
    clientId: 'dev',
    // endpoint: 'http://localhost:5000',
    // clientId: 'dev',
    domainCode: "BASECAMPHO",
    distributionChannelCode: "XWBE",
    cultureCode: "en-US",
    platformCode: 'WBE',
    action: 'WBEBooking'
  },
  timeout: 20,
  storeKey: 'BaseStack-C-W',
  application: "WBE",
  StudentPortalSite: "https://xncrs3.xnhotels.com/xms/rsbe/rsp",
  webAppPathName: "/xms/wbe/devfunc",
  enableBookingDiscount: true,
  timeInMinutesToResendEmail: 15,
  keyCloakConfig: {
    url: "https://account-stage.basecampstudent.com/stage/auth",
    realm: "mbc-stage",
    clientId: "protel-web"
  },
  isUsingExternalIdentityServer: true,
  email: 'waitlist@basecamp.com',
  googleTagManagerId: 'GTM-T8ZXJSV',
  googleTagManagerPageViewTriggerEventName: 'virtualPageView',
  useExternalStudentPortalSite: false,
  availableLanguageCodes: ['en', 'de', 'pl', 'da', 'es', 'pt', 'it', 'zh'],
  logoHeaderRedirectUrl: '',
  // Remove "NonSpecific" gender option from dropdown list.
  removeNonSpecificGenderOption: true,
  hideErrorCodeInFailureApiMessage: false,
  hideEmptyUtilitiesOnBookingDetailForCountryCode: ['de'],
  contactLink: 'https://stage.basecampstudent.com/contact/',
  helpLink: 'https://stage.basecampstudent.com/contact/',
  RSPSite: 'https://xncrs3.xnhotels.com/xms/rpmv3duo/rsp',
  showPromoCodeOnResultPage: true,
  themeDefault: 'Triberal',
  themeRemoteUrl: 'https://cdn.xnglobalres.com/wbs_hotel_media/themes/theme.json',
  enableConfigTheme: true,

  oktaConfig: {
    domain: "dev-y1w4ay5przewy1r1.us.auth0.com",
    clientId: "RCdSr5kap25wPQYj44B5H2k5OfjBw6kf",
    authorizationParams: {
      audience: "dev-y1w4ay5przewy1r1.us.auth0.com/api/v2/"
    },
    apiUri: "https://localhost:4201",
    appUri: "http://localhost:4201",
    errorPath: "/error"
  },
  externalAuthorizationProvider: "Okta",
  isShowSoldOutRoomType: true,

  privacyPolicyLink: 'https://www.xiorstudenthousing.eu/privacy-policy/',
  cookiePolicyLink: 'https://www.xiorstudenthousing.eu/cookie-policy/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
